module.exports = __webpack_public_path__ + "static/img/img_23.9c2632e.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/enterprise/images/img_23.webp
// module id = CKg7
// module chunks = 4